import { formatApiError } from '@/lib/format-api-error';

const LANDING_ERROR_MESSAGES: Record<string, string> = {
	'Build not found': 'Сборка не найдена или APK ещё не готов в билдере',
	'Build has no APK': 'У этой сборки нет APK. Дождитесь окончания сборки',
	'Failed to sync APK':
		'Не удалось получить APK из билдера. Попробуйте позже или загрузите файл вручную',
	'APK from build server failed integrity check':
		'APK с сервера сборки повреждён. Пересоберите или загрузите файл вручную',
	'Invalid APK file': 'Файл не является корректным APK',
	'APK exceeds 200 MB limit': 'APK больше 200 МБ',
	'APK file is required': 'Выберите файл APK',
	'Failed to persist APK': 'Не удалось сохранить APK',
	'Invalid buildId': 'Некорректный идентификатор сборки',
	'Template cannot be opened in the constructor':
		'Этот шаблон загружен архивом и открывается только заменой ZIP',
};

function mapByPrefix(message: string): string | null {
	if (message.startsWith('Upload rate limit exceeded')) {
		return 'Слишком много загрузок. Подождите час';
	}
	if (message.startsWith('Upload limit exceeded')) {
		return 'Достигнут лимит загруженных APK';
	}
	return null;
}

export function formatLandingApiError(data: unknown, status?: number): string {
	if (status === 413) {
		return 'Файл слишком большой';
	}

	const raw = formatApiError(data);
	if (raw) {
		const mapped = LANDING_ERROR_MESSAGES[raw] ?? mapByPrefix(raw);
		if (mapped) {
			return mapped;
		}
	}

	if (status === 502) {
		return 'Не удалось получить APK из билдера. Попробуйте позже или загрузите файл вручную';
	}

	return raw ?? 'Неизвестная ошибка';
}
